import type { PostHog } from "posthog-js";
import { SHREDDED_EXCLUDED_FLOW_IDS } from "libs/recipes/src/lib/recipes";

export const SHREDDED_AA_VARIANT_PROPERTY = "shredded_aa_variant";

type ShreddedAaVariant = "control" | "test";
type ShreddedAaSetOnceProperty = Record<
  typeof SHREDDED_AA_VARIANT_PROPERTY,
  ShreddedAaVariant
>;

interface GetShreddedAaSetOncePropertyArgs {
  posthog: Pick<PostHog, "getFeatureFlag">;
  flowId?: string;
}

const isShreddedAaVariant = (variant: unknown): variant is ShreddedAaVariant =>
  variant === "control" || variant === "test";

export const getShreddedAaSetOnceProperty = ({
  posthog,
  flowId,
}: GetShreddedAaSetOncePropertyArgs): ShreddedAaSetOnceProperty | undefined => {
  if (flowId && SHREDDED_EXCLUDED_FLOW_IDS.has(flowId)) {
    return undefined;
  }

  const variant = posthog.getFeatureFlag("shredded-AA-Test");
  if (!isShreddedAaVariant(variant)) {
    return undefined;
  }

  return { [SHREDDED_AA_VARIANT_PROPERTY]: variant };
};
